import React from 'react'

const NuestroTrabajo = () => {
  
  return (
    <div className="containersx">
      <h2 className="header">¿Por qué elegir a Cue Ilisound para tu próximo evento?</h2>
      <div className="content">
        <div className="box">
          <h3>Equipos de última generación</h3>
          <p>Nos aseguramos de que nuestros equipos de sonido e iluminación sean de la más alta calidad para garantizar que tus eventos tengan un sonido y una iluminación excepcionales.</p>
        </div>
        <div className="box">
          <h3>Expertos en el campo</h3>
          <p>Nuestro equipo de profesionales altamente capacitados tiene la experiencia necesaria para garantizar que tus eventos sean un éxito, sin importar el tipo de evento que estés planeando.</p>
        </div>
        <div className="box">
          <h3>Servicio personalizado</h3>
          <p>Trabajamos estrechamente contigo para asegurarnos de que tus eventos sean exactamente como los imaginaste. Desde la selección de la música hasta la iluminación, todo se personaliza para adaptarse a tus necesidades y preferencias.</p>
        </div>
        <div className="box">
          <h3>Confiabilidad garantizada</h3>
          <p>Entendemos la importancia de los eventos y la necesidad de que todo salga bien. Es por eso que nos aseguramos de ser puntuales, confiables y de proporcionar un servicio excepcional en todo momento.</p>
        </div>
      </div>
    </div>
  );
}

export default NuestroTrabajo